module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-9654.a0026ace.jpg";